<template>
  <v-card id="top-page" style="background-color: #eef2f5; max-height: 100vh">
    <v-card
      class="container_main d-flex align-center justify-content-end rounded-0 bg"
      width="100vw"
      min-height="100vh"
      style="justify-content: end"
    >
      <v-card
        class="pa-10 d-flex flex-column align-center justify-space-between rounded-xl mt-5 mr-20"
        style="background-color: rgba(255, 255, 255, 0.8)"
        width="800px"
        height="auto"
      >
        <h2>Maintenance Request</h2>
        <v-card
          class="pa-10 d-flex flex-column align-center justify-space-between rounded-md card"
          width="100%"
          height="wrap-content"
        >
          <div
            style="width: 100%"
            class="d-flex flex-column align-center justify-space-between"
          >
            <div class="box-field">
              <h6 class="title">1. Date of request:</h6>
              <input
                class="value"
                type="date"
                v-model="requestBody.RequestDt"
              />
            </div>
            <div class="box-field">
              <h6 class="title">2. Facility Location:</h6>
              <v-select
                class="value"
                :rules="active ? [rules.required] : []"
                v-model="requestBody.EquipID"
                :items="locationList"
              >
              </v-select>
            </div>
            <div class="box-field">
              <h6 class="title">3. Area issue is occuring in:</h6>
              <v-text-field
                label="Enter your answer"
                :rules="active ? [rules.required] : []"
                light
                v-model="requestBody.PKV_Area_c"
                class="value"
              />
            </div>
            <div class="box-field">
              <h6 class="title">4. Staff Member Requesting Repair:</h6>
              <v-text-field
                label="First Name"
                light
                :rules="active ? [rules.required] : []"
                v-model="requestBody.PKV_EmpReq_c_first"
                class="value-50"
              />
              <v-text-field
                label="Last Name"
                :rules="active ? [rules.required] : []"
                light
                v-model="requestBody.PKV_EmpReq_c_last"
                class="value-50"
              />
            </div>
            <div class="box-field">
              <h6 class="title">5. Email:</h6>
              <v-text-field
                label="Email"
                :rules="active ? [rules.required] : []"
                light
                v-model="requestBody.email"
                class="value"
              />
            </div>
            <div class="box-field">
              <h6 class="title">6. Is this repair of an urgent matter:</h6>
              <v-select
                class="value"
                :rules="active ? [rules.required] : []"
                v-model="requestBody.Priority"
                :items="priorityList"
              >
              </v-select>
            </div>
            <div class="box-field">
              <h6 class="title">
                7. Does this request have direct impact to a resident:
              </h6>
              <input
                type="checkbox"
                class="chckbox-20"
                :value="requestBody.PKV_DirImp_c"
                v-model="requestBody.PKV_DirImp_c"
              />
            </div>
            <div class="box-field">
              <h6 class="title">
                8. Document as much detail as possible below:
              </h6>
              <v-text-field
                label="Enter your answer"
                light
                :rules="active ? [rules.required] : []"
                v-model="requestBody.IssueDesc"
                class="value"
              />
            </div>
            <div style="width: 100%" class="d-flex align-center justify-center">
              <g-recaptcha
                style="width: 100%"
                data-sitekey="6LcEqtQlAAAAAGHpVRo-Yb6sVo0o_3fa9jT2qhoP"
                class="input-group--focused d-flex justify-center"
                :data-validate="validate"
                :data-callback="callback"
              >
                <v-btn
                  elevation="2"
                  min-width="150px"
                  :loading="loader"
                  :disabled="loading"
                  style="color: #1a535e"
                  class="button-submit input-group--focused"
                  >Submit Request</v-btn
                >
              </g-recaptcha>
            </div>
            <div class="GotoLogin">
              <a class="switchTabMsg" @click="gotoLogin"
                >Already have an account? Log in</a
              >
            </div>
          </div>
        </v-card>
      </v-card>
    </v-card>
  </v-card>
</template>
<script>
import gRecaptcha from "@finpo/vue2-recaptcha-invisible";
import {
  callBAQEquip,
  methodCreateRequestPreLogin,
} from "@/store/Method/index";
export default {
  components: {
    gRecaptcha,
  },
  data() {
    return {
      loading: false,
      loader: null,
      locationList: ["1940"],
      equipLocList: [],
      priorityList: [
        "HIGH",
        "LOW",
        "NORMAL",
        "Immediate(Forward Schedule)",
        "VERY HIGH",
        "VERY LOW",
      ],
      requestBody: {
        RequestDt: new Date(),
        EquipID: "",
        PKV_Area_c: "",
        PKV_EmpReq_c_last: "",
        PKV_EmpReq_c_first: "",
        Priority: "",
        IssueDesc: "",
        PKV_DirImp_c: true,
        email: "",
      },
    };
  },
  computed: {
    rules() {
      return {
        required: (value) => !!value || this.$t("required"),
      };
    },
  },
  async mounted() {
    let today = new Date();
    let year = today.getFullYear();
    let month = (today.getMonth() + 1).toString().padStart(2, "0");
    let day = today.getDate().toString().padStart(2, "0");
    this.requestBody.RequestDt = `${year}-${month}-${day}`;
    this.getEquipmentID();
  },
  watch: {},
  methods: {
    gotoLogin() {
      this.$router.push("/login");
    },
    async getEquipmentID() {
      await callBAQEquip().then((res) => {
        this.locationList = [];
        this.equipLocList = res;
        res.forEach((element) => {
          this.locationList.push(element.Equip_Description); //Equip_EquipID
        });
        this.$forceUpdate();
      });
    },
    validate() {
      return true;
    },
    async callback(token) {
      if (this.loader == "loading") return;
      if (
        !this.requestBody.EquipID ||
        !this.requestBody.PKV_Area_c ||
        !this.requestBody.PKV_EmpReq_c_last ||
        !this.requestBody.PKV_EmpReq_c_first ||
        !this.requestBody.Priority ||
        !this.requestBody.IssueDesc ||
        !this.requestBody.email
      ) {
        alert(
          "Please provide details regarding the issue you are experiencing."
        );
        this.active = true;
        return;
      }
      this.loader = "loading";
      if (!token) {
        alert("Please check you are not robot!!!");
        return;
      }
      let equip = this.equipLocList.find(
        (i) =>
          i.Equip_Description.toLowerCase() ==
          this.requestBody.EquipID.toLowerCase()
      );
      if (equip) this.requestBody.EquipID = equip.Equip_EquipID;
      let prio = "";
      switch (this.requestBody.Priority) {
        case "Immediate(Forward Schedule)":
          prio = "IMMED";
          break;
        case "VERY HIGH":
          prio = "VHIGH";
          break;
        case "VERY LOW":
          prio = "VLOW";
          break;
        default:
          prio = this.requestBody.Priority;
      }
      this.requestBody.Priority = prio;
      methodCreateRequestPreLogin(this.requestBody).then((res) => {
        this.loader = null;
        if (res) {
          alert("Your request has ID: " + res);
          let today = new Date();
          let year = today.getFullYear();
          let month = (today.getMonth() + 1).toString().padStart(2, "0");
          let day = today.getDate().toString().padStart(2, "0");
          this.requestBody = {
            RequestDt: `${year}-${month}-${day}`,
            EquipID: "",
            PKV_Area_c: "",
            PKV_EmpReq_c_last: "",
            PKV_EmpReq_c_first: "",
            Priority: "",
            IssueDesc: "",
            email: "",
            PKV_DirImp_c: true,
          };
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.mr-20 {
  margin-right: 10%;
}

.GotoLogin {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.switchTabMsg {
  text-align: center;
  width: fit-content;
  color: black !important;
  text-decoration: underline;
  font-size: 0.8rem;
}

.justify-content-end {
  justify-content: end;
}

.card_request_div_container {
  width: 40%;
  display: flex;
  max-height: 100vh;
  justify-content: center;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}

.v-expansion-panel::before {
  box-shadow: none;
}

.justify-space-between {
  justify-content: center;
}

.button-submit {
  width: 100%;
  padding-top: 0.625rem;
  background-color: transparent;
  color: #1a535e;
  border-radius: 2em;
  border-width: 2px;
  background: 0 0;
  font-weight: bold;
}

.bg {
  flex-wrap: wrap;
  background-size: cover;
  background-image: url("https://www.datavtech.com/wp-content/uploads/2022/11/Contact-us.png?id=468");
  background-color: #eef2f5;
}

.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}

.mb-20 {
  margin-bottom: 50px;
}

.table-custom {
  width: 100%;
  margin-top: 20px;
}

table,
th,
td {
  border: 1px solid #ddd;
  height: 50px;
  border-collapse: collapse;
}

th {
  border-bottom: 2px solid black;
}

td {
  text-align: center;
}

.input-search {
  margin-top: 5px;
  margin-bottom: 5px;
  border-style: solid;
  outline: #1a535e;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}

@import "@/assets/css/standard.scss";

.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 48px;
}

::v-deep .v-expansion-panel-header__icon {
  margin-left: 0 !important;
}

::v-deep .v-expansion-panel-header__icon {
  margin-right: 10px !important;

  .mdi-chevron-down::before {
    color: #21698f;
  }
}

.card_request_div_container {
  display: flex;
  justify-content: center;
}
.width-40 {
  width: 40% !important;
}
.width-100 {
  width: 100% !important;
}
.v-expansion-panel::before {
  box-shadow: none;
}

.justify-space-between {
  justify-content: center;
}

.card_request {
  background-color: #eef2f5;
  align-items: start;
  width: 100%;
  margin: 0 10px 0 0;
}

.banner {
  width: 100%;
  height: 48px;
  background-color: #d1dfe3;
  color: black;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
  font-size: 1.2em;
  margin: 0 10px 0;
}

.cards {
  width: 60%;
  margin-top: 10px;
  min-height: auto;
  height: wrap-content;
  border: none;
  border-radius: 0%;
  display: flex;
  flex-direction: row;
  align-items: center;
  row-gap: 10px;
  column-gap: 10px;
  justify-content: center;
  align-content: flex-start;
  flex-wrap: wrap;
  box-shadow: white;
  background-color: #eef2f5;
}

#top-page > .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}

.card_item {
  width: 200px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  align-content: flex-end !important;
  height: 100px;

  div:nth-child(1) {
    width: 90%;

    p {
      color: black;
      font-size: 0.8em;
      margin-bottom: 0;
      font-weight: bold;
    }
  }

  .v-card {
    .v-icon {
      font-size: 2rem;
      color: white;
    }

    h1 {
      color: white;
      font-size: 1.2rem;
      margin-left: 5px;
    }

    h2 {
      color: white;
      font-size: 1rem;
      margin-left: 5px;
    }
  }
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}

.card {
  background-color: rgba(255, 255, 255, 0.8);
  margin-top: 10px;
}

.v-expansion-panel-header {
  min-height: 48px;
  border-radius: 4px !important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.card-inside {
  height: 50%;
  justify-content: start;
  width: 90%;
  align-items: center;
  padding: 0 0 0 10px;
}

.button-submit {
  width: 100%;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  background-color: transparent;
  color: #1a535e;
  border-radius: 2em;
  border-width: 2px;
  background: 0 0;
  font-weight: bold;
  margin-top: 10px;
}

.Header {
  font-weight: 700;
  font-size: 1.2em;
  height: 20px;
  margin-top: 10px;
  background-color: #d1dfe3;
  color: black;
}

a:hover {
  font-weight: bolder;
}

.card_request_div {
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-right: 10px;
  margin-left: 10px;
}

th {
  border-bottom: 2px solid black;
}

td {
  text-align: center;
}

.image_card {
  width: 35%;
  margin: 10px 10px 0 10px;

  .image_ad {
    width: 100%;
  }
}

@media only screen and (max-width: 1000px) {
  .cards {
    width: 100%;
  }
}

.container_main {
  justify-content: center;
  height: wrap-content;
  flex-wrap: wrap;
  background-size: cover;
  background-color: #eef2f5;

  .cards {
    @media (max-width: 1024px) {
      width: 100%;
    }
  }

  .image_card {
    @media (max-width: 1024px) {
      width: 100%;
    }
  }

  .card_request_div,
  .card_request_div_container {
    @media (max-width: 1024px) {
      width: 100%;
    }
  }
}

.card_item:nth-child(4n + 1) {
  .card-inside {
    background-color: #008baa !important;
  }
}

.card_item:nth-child(4n + 2) {
  .card-inside {
    background-color: #0187d9 !important;
  }
}

.card_item:nth-child(4n + 3) {
  .card-inside {
    background-color: #f8811c !important;
  }
}

.card_item:nth-child(4n + 4) {
  .card-inside {
    background-color: #a2d183 !important;
  }
}

.box-field {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  padding: 15px 0;
  font-size: 16px !important;

  .title {
    font-weight: 400;
    width: 40%;
    font-size: 1.1rem !important;
  }
  .title-80 {
    font-weight: 400;
    width: 90%;
    font-size: 1.1rem !important;
  }
  .title-auto {
    font-weight: 400;
    width: auto;
    font-size: 1.1rem !important;
  }

  .value {
    margin-left: 10px;
    font-size: inherit;
    width: 60%;
    // outline: #d1dfe3;
  }
  .value-50 {
    margin-left: 10px;
    width: 25%;
    font-size: inherit;
    // outline: #d1dfe3;
  }
}
.chckbox-20 {
  border: 10px solid black;
  height: 1.25em;
  width: 1.25em;
  margin-left: 7px;
  color: black;
  accent-color: black;
  background-color: black;
  box-sizing: border-box;
  border-radius: 2px;
  position: relative;
}
</style>
